import React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import screen from 'superior-mq';
import { bp, hover } from 'Styles/helpers';
import InlineLink from '../inline-link';

const StyledDonateButton = styled(InlineLink)`
  --anchor-hover-color: #fff;
  padding: 8px 30px;
  background-color: ${props => props.theme.blue};
  font-size: ${rem(25)};
  font-family: ${props => props.theme.condensedFont};
  color: #fff;
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  z-index: 4;
  transition: background-color .3s ease;

  ${props => hover(`
    background-color: ${props.theme.black};
  `)}

  ${screen.below(bp.portrait, `
    padding: 20px 40px;
  `)}
`;

const DonateButton = ({ href, ...props }) => (
  <StyledDonateButton href="/donate" {...props}>
    Donate
  </StyledDonateButton>
);

export default DonateButton;
